import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/items`;

// CREATE =>  POST: add a new product to the server
export function createItem(item) {
    return axios.post(API_URL, { ...item });
}

// READ
export function getAllItems() {
    return axios.get(API_URL);
}

export function getPaginatedItems(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getItemById(itemId) {
    return axios.get(`${API_URL}/${itemId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the item on the server
export function updateItem(itemId, item) {
    return axios.put(`${API_URL}/${itemId}`, { ...item });
}


// DELETE => delete the product from the server
export function deleteItem(itemId) {
    return axios.delete(`${API_URL}/${itemId}`);
}
